import Urls from 'Containers/Urls';

function pathToRegex(path: string): RegExp {
  const regexStr = path.replace(/:[^/]+/g, '[^/]+').replace(/\//g, '\\/');
  return new RegExp(`^${regexStr}$`);
}

const relatedRoutes = [
  Urls.startVerification,
  Urls.resultVerification,
  Urls.twoFactorVerificationActivity,
];

export function isAuthRelatedRoute(pathname?: string): boolean {
  const currentPath = pathname ?? window.location.pathname;
  return relatedRoutes.some((route) => {
    const regex = pathToRegex(route);
    return regex.test(currentPath);
  });
}
